// extracted by mini-css-extract-plugin
module.exports = {"comingSoon":"ComingSoon_comingSoon__2rwE3","downloadButtons":"ComingSoon_downloadButtons__1d6qA","downloadButton":"ComingSoon_downloadButton__2rjbX"};